import React from "react"
import { Box, Typography } from "@material-ui/core"

export const NoFields: React.FC = () => {
  return (
    <Box display="inline-block" border="1px solid" borderColor="grey.200" p={2}>
      <Typography variant="body1">
        No fields have been added to this schema yet.
      </Typography>
    </Box>
  )
}
